import { ChevronDown } from "lucide-react";

interface CollapsibleSectionProps {
  id: string;
  title: string;
  icon: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  isDanger?: boolean;
  children: React.ReactNode;
  spacing?: string;
  /** Optional onboarding tour anchor (data-tour-target). */
  dataTourTarget?: string;
}

export function CollapsibleSection({
  id,
  title,
  icon,
  isOpen,
  onToggle,
  isDanger = false,
  children,
  spacing = "space-y-6",
  dataTourTarget,
}: CollapsibleSectionProps) {
  return (
    <div id={id} className="scroll-mt-6" data-tour-target={dataTourTarget}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-2 py-3 px-1 text-left group rounded-md hover:bg-muted/30 transition-colors"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-2">
          <span className={isDanger ? "text-destructive" : "text-muted-foreground"}>
            {icon}
          </span>
          <span className={`text-xl font-semibold ${isDanger ? "text-destructive" : ""}`}>
            {title}
          </span>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-muted-foreground transition-transform duration-200 mr-1 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      <div
        className={`grid transition-all duration-300 ease-in-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
      >
        <div className="overflow-hidden">
          <div className={`${spacing} pb-2`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
